import React from "react";
import { motion } from "framer-motion";
import Reveal from "./Reveal";
import { founder as F } from "../mock";

const Founder = () => {
  return (
    <section className="bg-[#ececec] py-24 md:py-32 px-5">
      <div className="max-w-[1100px] mx-auto">
        <Reveal>
          <p className="text-[#8a8a8a] text-sm mb-3">{F.eyebrow}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-cal text-5xl md:text-7xl mb-16 text-[#141414]">{F.title}</h2>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-12 items-start">
          <Reveal>
            <div className="relative">
              <div className="rounded-[32px] overflow-hidden bg-[#ddd]">
                <img src={F.image} alt="founder" className="w-full h-[420px] object-cover" />
              </div>
              <motion.img
                src={F.circle}
                alt="badge"
                animate={{ rotate: 360 }}
                transition={{ duration: 18, repeat: Infinity, ease: "linear" }}
                className="absolute -bottom-6 -right-6 w-24 h-24"
              />
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div>
              <h3 className="font-cal text-3xl text-[#141414] mb-6">{F.label}</h3>
              <p className="text-[#5f5f5f] leading-relaxed mb-10">{F.bio}</p>
              <div className="space-y-0">
                {F.timeline.map((t) => (
                  <div
                    key={t.role}
                    className="flex items-center justify-between py-4 border-t border-[#d5d5d5]"
                  >
                    <span className="text-[#141414] font-medium">{t.role}</span>
                    <span className="text-[#8a8a8a] text-sm">{t.period}</span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Founder;
